import React from 'react'
import SearchResults from '@cmp/site/SearchResults'

type Props = {
  programName: string
  options: any
}

const System = ({ programName, options }: Props) => {
  const programs: { [key: string]: React.ElementType } = {
    SearchResults
  }

  if (programs[programName]) {
    const Cmp = programs[programName]
    return <Cmp {...options} />
  } else {
    return <div>unhandled {programName}</div>
  }
}

export default System
